document.addEventListener('click', function(e) {
  const title = e.target.closest('.brewguide_title');

  if (!title) return;

  const parentBox = title.closest('.product-info-left_content-bottom');

  if (parentBox) {
    parentBox.classList.toggle('active');
  }
});

(function() {

  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  }   

})();

document.addEventListener("DOMContentLoaded", function () {

  // Remove Shopify form success params from URL
  if (
    window.location.search.includes("customer_posted=true") ||
    window.location.hash === "#ContactFooter"
  ) {
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  }

  const popup = document.getElementById("newsletter-popup");
  const closeBtn = document.getElementById("newsletter-popup-close");

  // Get Cookie
  function getCookie(name) {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
        name.replace(/([.$?*|{}()[\]\/+^])/g, "\\$1") +
        "=([^;]*)"
      )
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  // Set Cookie
  function setCookie(name, value, hours) {
    let date = new Date();

    date.setTime(date.getTime() + hours * 60 * 60 * 1000);

    document.cookie =
      name + "=" + value +
      "; expires=" + date.toUTCString() +
      "; path=/";
  }

  // Show Popup
  if (!getCookie("newsletter_popup")) {
    setTimeout(function () {
      popup?.classList.add("active");
    }, 2000);
  }

  if(closeBtn){
    // Close Popup
    closeBtn.addEventListener("click", function () {
      popup.classList.remove("active");
  
      // Cookie set for 24 hours
      setCookie("newsletter_popup", "true", 24);
    });
  }

});

// start mobile menu close

class DrawerClose extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    this.closest('details').querySelector('summary').click();
  }
}

customElements.define('drawer-close', DrawerClose);

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    if (!content) return;
    accordion.classList.add("active");
    content.style.maxHeight = "max-content";
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    if (!content) return;
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");

    if (intro && content) {
      intro.addEventListener("click", (e) => {
        const currentAccordion = e.target.closest("[js-acc-item]");

        if (currentAccordion.classList.contains("active")) {
          closeAccordion(currentAccordion);
          return;
        }

        accordions.forEach((acc) => closeAccordion(acc));
        openAccordion(currentAccordion);
      });
    }
  });
}

(function () {
  faq_taggol();

  // Transparent header if needed
  if (document.querySelector("[data-header-tans]")) {
    document.body.classList.add("header-transparent");
  }

  // ❌ Remove auto-open first accordion (NO ACTION HERE)
})();


const observer = new MutationObserver(function () {
    const passwordInput = document.getElementById('password');

    if (passwordInput) {
        observer.disconnect();

        const label = document.querySelector('label[for="password"]');
console.log(label,"labellabellabel")
        function toggleLabel() {
            label.style.display = passwordInput.value.trim() ? 'none' : 'block';
        }

        toggleLabel();
        passwordInput.addEventListener('input', toggleLabel);
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});




// console.log(document.querySelector('.swiper_custom .swiper-slide-active'),"ppppppp")
// if (getswiper) {
//   const sliderOptions = JSON.parse(
//     getswiper.getAttribute('data-slider-options')
//   );

//   const swiper = new Swiper(getswiper, sliderOptions);

//   let currentIndex = -1;

//   function updateSlideColor() {
//     if (currentIndex === swiper.realIndex) return;

//     currentIndex = swiper.realIndex;

//     const activeSlide = swiper.slides[swiper.activeIndex];
//     const color = activeSlide.dataset.color;

//     const menuColor = document.querySelectorAll('.header__inline-menu ul li span');
//     const svgcode = document.querySelector('.header__heading-logo-wrapper svg g path');
//      const menuIcons = document.querySelectorAll('.header__icon svg path');
//      const annoucetext = document.querySelectorAll('.announcement-bar__message p');
//      const announcementicon  = document.querySelectorAll('.ann-inner-wrapper svg path');

//       menuColor.forEach((span) => {
//         span.style.color = color;
//       });
//       svgcode.style.fill = color;
     

//       menuIcons.forEach((path) => {
//         path.style.fill = color;
//       });
//        annoucetext.forEach((p) => {
//         p.style.color = color;
//       });
//         announcementicon.forEach((Apath) => {
//         Apath.style.fill = color;
//       });

//   }

//   swiper.on('init', updateSlideColor);

//   swiper.on('slideChangeTransitionEnd', updateSlideColor);

//   swiper.init();
// }



const getswiper = document.querySelector('.swiper_custom');

if (getswiper) {
  const sliderOptions = JSON.parse(
    getswiper.getAttribute('data-slider-options')
  );

  const swiper = new Swiper(getswiper, sliderOptions);

  let currentIndex = -1;

  function updateSlideColor(force = false) {
    if (!force && currentIndex === swiper.realIndex) return;

    currentIndex = swiper.realIndex;

    const activeSlide = swiper.slides[swiper.activeIndex];

    if (!activeSlide) return;

    const color = activeSlide.dataset.color;

    if (!color) return;

    // Header menu
    const menuColor = document.querySelectorAll(
      '.header__inline-menu ul li span'
    );

    // Header logo
    const svgcode = document.querySelector(
      '.header__heading-logo-wrapper svg g path'
    );

    // Header icons
    const menuIcons = document.querySelectorAll(
      '.header_icon_color svg path'
    );

    // Announcement text
    const annoucetext = document.querySelectorAll(
      '.announcement-bar__message p'
    );

    // Announcement icon
    const announcementicon = document.querySelectorAll(
      '.ann-inner-wrapper svg path'
    );

    // Announcement links
    const annoucetext_link = document.querySelectorAll(
      '.announcement_contact li a'
    );

    // Menu text color
    menuColor.forEach((span) => {
      span.style.color = color;
    });

    // Logo color
    if (svgcode) {
      svgcode.style.fill = color;
    }

    // Header icons color
    menuIcons.forEach((path) => {
      path.style.fill = color;
    });

    // Announcement text color
    annoucetext.forEach((p) => {
      p.style.color = color;
    });

    // Announcement icon color
    announcementicon.forEach((path) => {
      path.style.fill = color;
    });

    // Announcement links color
    annoucetext_link.forEach((link) => {
      link.style.color = color;
    });

    // Announcement border
    const announcementBar = document.querySelector(
      '.announcement-bar-wrapper'
    );

    if (announcementBar) {
      announcementBar.style.borderBottom = `1px solid ${color}`;
    }

    // Cart count color
    const carttext = document.querySelectorAll(
      '.cart-count-bubble'
    );

    carttext.forEach((cartt) => {
      cartt.style.color = color;
    });
  }

  // Remove only the styles applied by updateSlideColor()
  function removeAppliedStyles() {
    document
      .querySelectorAll('.header__inline-menu ul li span')
      .forEach((span) => {
        span.style.removeProperty('color');
      });

    const svgcode = document.querySelector(
      '.header__heading-logo-wrapper svg g path'
    );

    if (svgcode) {
      svgcode.style.removeProperty('fill');
    }

    document
      .querySelectorAll('.header_icon_color svg path')
      .forEach((path) => {
        path.style.removeProperty('fill');
      });

    document
      .querySelectorAll('.announcement-bar__message p')
      .forEach((p) => {
        p.style.removeProperty('color');
      });

    document
      .querySelectorAll('.ann-inner-wrapper svg path')
      .forEach((path) => {
        path.style.removeProperty('fill');
      });

    document
      .querySelectorAll('.announcement_contact li a')
      .forEach((link) => {
        link.style.removeProperty('color');
      });

    const announcementBar = document.querySelector(
      '.announcement-bar-wrapper'
    );

    if (announcementBar) {
      announcementBar.style.removeProperty('border-bottom');
    }

    document
      .querySelectorAll('.cart-count-bubble')
      .forEach((cart) => {
        cart.style.removeProperty('color');
      });
  }

  // Swiper events
  swiper.on('init', () => {
    if (window.scrollY <= 0) {
      updateSlideColor(true);
    }
  });

  swiper.on('slideChangeTransitionEnd', () => {
    if (window.scrollY <= 0) {
      updateSlideColor(true);
    }
  });

  // Initialize Swiper
  swiper.init();

  // Initial load
  if (window.scrollY <= 0) {
    updateSlideColor(true);
  }

  let isAtTop = window.scrollY <= 0;

  function handleScroll() {
    const atTop = window.scrollY <= 0;

    if (!atTop && isAtTop) {
      isAtTop = false;
      removeAppliedStyles();
    }

    if (atTop && !isAtTop) {
      isAtTop = true;

      updateSlideColor(true);
    }
  }

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });
}

